import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Setzt die Scroll-Position bei jeder Route-Änderung auf den Anfang der Seite zurück
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;

